import home from "../../pages/home components/Home";
import appointment from "../../pages/appointment components/Home";
import previewVideo from "../../pages/Liveliness/PreviewVideo";
import Liveliness from "../../pages/Liveliness/CaptureVideo";
import Success from "../../pages/Success/";
import Verification from "../../pages/Verification/Verificaion";
import UploadDocument from "../../pages/UploadDocument/UploadDocument";
import EventBooking from "../../pages/Booking/EventBooking/EventBooking";
import AppointmentBooking from "../../pages/Booking/AppointmentBooking/AppointmentBooking";
import EventBookingDetails from "../../pages/Booking/EventBooking/EventBookingDetails";
import AppointmentBookingDetails from "../../pages/Booking/AppointmentBooking/AppointmentBookingDetails";
import AadharverificaionDetails from "../../pages/Verification/Aadharverificaion/AadharverificaionDetails";
import DrivingLicenceDetails from "../../pages/Verification/DrivingLicence/DrivingLicenceDetails";
import BioVerificaion from "./../../pages/Booking/BioVerification/BioVerificaion";
import TrackAppointment from "./../../pages/Track Appointment/index.js";

import ContactUs from "../../pages/home components/Contact.js";
import AboutUs from "../../pages/home components/AboutUs.js";

const applicationLayoutRoutes = {
  homePageRoute: {
    ID: "home",
    path: "/",
    element: home,
  },

  ContactUs: {
    ID: "ContactUs",
    path: "/contact-us",
    element: ContactUs,
  },

  AboutUs: {
    ID: "AboutUs",
    path: "/about-us",
    element: AboutUs,
  },

  appointmentPageRoute: {
    ID: "appointment",
    path: "/appointment",
    element: appointment,
  },

  TrackAppointmentPageRoute: {
    ID: "TrackAppointment",
    path: "/track-appointment",
    element: TrackAppointment,
  },

  previewVideoPageRoute: {
    ID: "previewVideo",
    path: "/previewVideo",
    element: previewVideo,
  },

  livelinessPageRoute: {
    ID: "liveliness",
    path: "/check-liveness",
    element: Liveliness,
  },

  Success: {
    ID: "Success",
    path: "/success",
    element: Success,
  },

  Verification: {
    ID: "Verification",
    path: "/verification",
    element: Verification,
  },

  UploadDocument: {
    ID: "UploadDocument",
    path: "/upload-document",
    element: UploadDocument,
  },
  EventBooking: {
    ID: "EventBooking",
    path: "/event-booking",
    element: EventBooking,
  },

  EventBookingDetails: {
    ID: "EventBookingDetails",
    path: "/event-booking-details",
    element: EventBookingDetails,
  },

  AppointmentBooking: {
    ID: "AppointmentBooking",
    path: "/appointment-booking",
    element: AppointmentBooking,
  },

  AppointmentBookingDetails: {
    ID: "AppointmentBookingDetails",
    path: "/appointment-booking-details",
    element: AppointmentBookingDetails,
  },

  AadharverificaionDetails: {
    ID: "AadharverificaionDetails",
    path: "/aadhar-verificaion-details",
    element: AadharverificaionDetails,
  },

  DrivingLicenceDetails: {
    ID: "DrivingLicenceDetails",
    path: "/driving-licence-details",
    element: DrivingLicenceDetails,
  },
  BioVerificaion: {
    ID: "BioVerificaion",
    path: "/bio-verification",
    element: BioVerificaion,
  },
};

export default applicationLayoutRoutes;
